<template>
  <section class="ugc-zoom-control">
    <div 
      id="zoomLabel"
      class="ugc-zoom-control-value">
      {{ zoomPercentage.toFixed(0) }}&#37;
    </div>
    <input
      class="ugc-zoom-control-input"
      @input="onChange"
      ref="zoomInput"
      v-model="zoomValue"
      type="range"
      :min="min"
      :max="max"
      role="slider"
      aria-labelledby="zoomLabel"
      :aria-valuemin="min"
      :aria-valuemax="max"
      :aria-valuenow="zoomValue"
    />
  </section>
</template>

<script>
import BaseUgcTool from "../BaseUgcTool";

const DEFAULT_PERCENT = 100;

export default {
  extends: BaseUgcTool,
  name: "UgcZoomControl",
  data() {
    return {
      min: 0,
      max: 200,
      minLimit: 0,
      scaleLimit: 0,
      originalScale: 0,
      zoomValue: 0,
      controlName: "zoom"
    };
  },
  methods: {
    onMouseWheel(opt) {
      const delta = Number(opt.e.deltaY);
      let zoom = Number(this.zoomValue);
      const min = Number(this.min);
      const max = Number(this.max);
      zoom = zoom + delta / 10;
      if (zoom > max) zoom = max;
      if (zoom < min) zoom = min;
      this.zoomValue = Number(zoom);
      this.onChange();
      opt.e.preventDefault();
      opt.e.stopPropagation();
    },
    onChange() {
      const img = this.fabricCanvas.getObjects("image")[0];
      const { zoomValue, minLimit, scaleLimit, scaleCoefficient } = this;
      // Because we don't want to scale the image until it not being visible, we are defining a lower scale limit and
      // if the zoom value is lower than that, we are going to calculate a proportional value
      const newScale =
        ((zoomValue > scaleLimit
          ? zoomValue
          : zoomValue * scaleCoefficient + minLimit) *
          this.originalScale) /
        DEFAULT_PERCENT;
      img.lockUniScaling = true;
      img.lockScalingFlip = true;
      img.scale(newScale);
      this.fabricCanvas.requestRenderAll();
    },
    onScaling() {
      const { imageScaleX } = this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex];
      const image = this.fabricCanvas.getObjects("image")[0];
      const objectScaleX = image.get("scaleX");
      this.zoomValue = Number(objectScaleX/imageScaleX*100);
      //this.zoomValue = this.calculateZoomValue({ imageScaleX, objectScaleX });
      // Prevent the image from being scaled bigger or smaller using the bezier lines
      if (this.zoomValue > this.max) {
        this.zoomValue = Number(this.max);
        this.onChange();
      } else if (this.zoomValue < this.min) {
        this.zoomValue = Number(this.min);
        this.onChange();
      }
    },
    calculateZoomValue({ imageScaleX, objectScaleX }) {
      let zoomValue = (objectScaleX * DEFAULT_PERCENT) / imageScaleX;
      if (zoomValue < this.scaleLimit) {
        zoomValue =
          ((objectScaleX * DEFAULT_PERCENT) / this.originalScale -
            this.minLimit) /
          this.scaleCoefficient;
      }
      return zoomValue;
    }
  },
  computed: {
    scaleCoefficient() {
      const { minLimit, scaleLimit } = this;
      return (scaleLimit - minLimit) / scaleLimit;
    },
    fabricCanvas() {
      return this.$store.state.ugc.stateManager.canvas;
    },
    zoomPercentage() {
      const percentage = Number(this.zoomValue);
      return percentage > 0 ? percentage : 0;
    },
    configuration() {
      return this.$store.state.utils.configuration;
    },
    minPlacementSize() {
      const { activeUGCComponent,  } = this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex];
      const {pdmModel} = this.$store.state.utils;
      const minPlacementSize = this.$store.state.utils.configuration.ugc.minPlacementSize;
      const minWidth = this.$store.state.utils.configuration.ugc.minPlacementSize;
      // Sk8-hi quarters placement is square, if that changes we can move this to the pdm
      const minHeight = pdmModel !== 'sk8-hi' && activeUGCComponent === 'quarters' ? minPlacementSize * 2 : minPlacementSize;
      return {minWidth,minHeight}
    }
  },
  created() {
    const { imageScaleX } = this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex];
    const image = this.fabricCanvas.getObjects()[0];
    const objectScaleX = image.get("scaleX");
    if(image.width < image.height) {
      this.min = Math.ceil(this.minPlacementSize.minWidth / image.width * 100);
      const placementMax = Math.ceil(image.width / this.minPlacementSize.minWidth * 100);
      this.max = (placementMax > 200) ? 200 : (placementMax < this.min) ? this.min : placementMax;
    } else {
      this.min = Math.ceil(this.minPlacementSize.minHeight / image.height * 100);
      const placementMax = Math.ceil(image.height / this.minPlacementSize.minHeight * 100);
      this.max = (placementMax > 200) ? 200 : (placementMax < this.min) ? this.min : placementMax;
    }
    
    this.originalScale = imageScaleX;
    this.zoomValue = Number((this.max===this.min) ? this.min : this.calculateZoomValue({ imageScaleX, objectScaleX }));
    this.fabricCanvas.on('object:scaling', this.onScaling);
    this.$eventBus.$on("canvas:mousewheel", this.onMouseWheel);
  },
  beforeDestroy() {
    this.fabricCanvas.off('object:scaling', this.onScaling);
    this.$eventBus.$off("canvas:mousewheel", this.onMouseWheel);
  }
};
</script>
